module.exports = __webpack_public_path__ + "static/ellen-armstrong-pic-1-e93e7ce8b9905cce66f1817e1d092519.jpg";